import React from 'react';

import { IconHamburger } from '@lightspeed/flame/Icon/Hamburger';

const Toggler = ({ ...rest }) => (
  <div className="cr-topbar__toggler">
    <a className="cr-topbar__toggler-link" {...rest}>
      <IconHamburger />
    </a>
  </div>
);

export default Toggler;
